<template>
  <div
    :class="`footer-container footer-container_${$store.state.sceneClassName}`"
  >
    <div class="footer">
      <div class="footer-content">
        <div class="foot">
          <div class="tel">0592-5929181</div>
          <p class="time">周一至周日 9:00-18:00</p>
          <div class="qr">
            <div class="gzh">
              <img :src="require('@/assets/images/gzh_qrcode.png')" alt="" />
              <p>关注知链公众号</p>
            </div>
            <div class="zsdp">
              <img :src="require('@/assets/images/sjxy_qrcode.jpg')" alt="" />
              <p>进入知链商家学院</p>
            </div>
          </div>
        </div>
       
        <dl>
          <dt>产品能力</dt>
          <dd>
            <a class="footer-href" href="/" target="_blank">商业变现</a>
          </dd>
          <dd>
            <a class="footer-href" href="/" target="_blank">品牌营销</a>
          </dd>
          <dd>
            <a class="footer-href" href="/" target="_blank">用户运营</a>
          </dd>
        </dl>
        <dl>
          <dt>技术服务</dt>
          <dd>
            <a class="footer-href" href="/" target="_blank">云技术</a>
          </dd>
        </dl>
        <dl>
          <dt>共享资源</dt>
          <dd>
            <a class="footer-href" href="" rel="nofollow">技术分享</a>
          </dd>
          <dd>
            <a class="footer-href" href="/" rel="nofollow">供应链</a>
          </dd>
        </dl>
        <dl>
          <dt>关于我们</dt>
          <dd>
            <a
              class="footer-href"
              href="/"
              data-count="pc-底部导航_公司相关_关于我们"
              >公司简介</a
            >
          </dd>
          <dd>
            <!-- <a class="footer-href" href="/contactUs" data-count="pc-底部导航_公司相关_联系我们">联系我们</a> -->
          </dd>
          <dd>
            <a
              class="footer-href"
              href="/"
              data-count="pc-底部导航_公司相关_加入我们"
              rel="nofollow"
              >加入我们</a
            >
          </dd>
          <dd>
            <a class="footer-href" href="/" rel="nofollow">公益计划</a>
          </dd>
        </dl>
        
      </div>
      <div v-if="$store.state.sceneClassName === 'app'" class="bottom_app">
        <div class="tel">0592-5929181</div>
        <p class="time">周一至周日 9:00-18:00</p>
        <div class="email">
          <p>客服支持：kefu@getchain.cn</p>
          <p>商务合作：support@getchain.cn</p>
          <p>渠道合作：partner@getchain.cn</p>
          <p>厦门地址：厦门大学国家科技园望海路39号3楼</p>
          <p>深圳地址：深圳市福田区华美大厦507</p>
        </div>
      </div>
      <div v-else class="bottom">
        <ul class="contact-way">
          <li class="address">厦门地址：厦门大学国家科技园望海路39号3楼</li>
          <li class="address">
            深圳地址：深圳市福田区华美大厦507室
          </li>
        </ul>
        <ul class="contact-way">
          <li class="email">客服支持：kefu@getchain.cn</li>
          <li class="email">商务合作：support@getchain.cn</li>
        </ul>
        <ul class="contact-way">
          <li class="email">渠道合作：partner@getchain.cn</li>
          <li>投诉意见：tousu@getchain.cn</li>
        </ul>
      </div>
      <div class="copyright">
        <p class="copyright-info">
          <span>Copyright © 2018-2021 厦门知链科技有限公司</span>
          <span>All Rights Reserved.</span>
          <a target="_blank" href="" class="link" rel="nofollow"
            >闽ICP备18002650号</a
          >
        </p>
        <div class="brand">
          <a target="_blank" href="" rel="nofollow">
            <img
              class="webInfo-ga-icon"
              :src="require('@/assets/images/beian.png')"
            />
            闽公网安备 35030502002020号
          </a>
          <a target="_blank" href="" rel="nofollow">
            <img
              class="webInfo-ga-icon"
              :src="require('@/assets/images/ebsIcon.png')"
            />
            工商网监 电子标识
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>
.footer-container {
  background: #161e30;
  .footer {
    max-width: 1380px;
    margin: 0 auto;
    padding: 0 50px;

    .footer-content .media-report,
    .footer-content .media-report a {
      max-width: 300px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .footer-content {
      padding-bottom: 20px;
      display: flex;
      justify-content: space-between;
      padding-top: 120px;
    }

    .footer-content .media-report a {
      display: block;
    }

    .footer-content dt {
      color: #fff;
      font-size: 16px;
      margin-bottom: 20px;
      line-height: 30px;
    }

    .footer-content .padding-t {
      padding-top: 16px;
    }

    .footer-content dd {
      line-height: 40px;
      font-size: 14px;
    }

    .footer-content dd a {
      color: #fff;
      opacity: 0.6;
    }

    .foot .tel {
      font-size: 30px;
      color: #fff;
      margin-bottom: 5px;
      height: 30px;
      font-weight: 500;
      color: rgba(255, 255, 255, 0.9);
      line-height: 30px;
    }

    .foot .time {
      font-size: 12px;
      color: #fff;
      opacity: 0.6;
      margin-bottom: 24px;
    }

    .foot .qr {
      display: flex;
      text-align: center;
    }

    .foot .qr .gzh {
      margin-right: 23px;
    }

    .foot .qr p {
      font-size: 12px;
      color: #fff;
      opacity: 0.6;
      line-height: 30px;
    }

    .bottom {
      padding: 5px 0;
      display: flex;
    }

    .bottom .contact-way {
      line-height: 29px;
      margin-right: 32px;
    }

    .bottom .contact-way li {
      font-size: 14px;
      color: #fff;
      opacity: 0.6;
    }

    .copyright {
      height: 35px;
      line-height: 35px;
      font-size: 12px;
      color: #fff;
      opacity: 0.3;
      display: flex;
      justify-content: space-between;
    }

    .copyright .webInfo-ga-icon {
      vertical-align: middle;
      margin-right: 5px;
    }

    .copyright .brand {
      display: flex;
    }

    .copyright .brand a {
      color: #fff;
      display: flex;
      align-items: center;
      margin: 0 20px;
    }

    .copyright .link {
      color: #fff;
    }
  }
}
.footer-container_app {
  .footer {
    padding: 0 0.72rem 1.3rem;
    .footer-content {
      padding: 0.8rem 0 0;
      flex-wrap: wrap;
      text-align: left;
      .foot {
        display: none;
      }
      & > dl {
        width: 50%;
        margin-bottom: 0.64rem;
        dt {
          font-size: 0.32rem;
        }
        dd {
          margin-top: 0.64rem;
        }
      }
    }

    .copyright {
      text-align: center;
      opacity: 1;
      height: auto;
      display: block;
      font-size: 0.2rem;
      color: #aaa;
      line-height: 0.45rem;
      a,
      .link {
        color: #999;
      }
      .copyright-info {
        span {
          &:nth-of-type(1) {
            display: block;
          }
        }
      }
      .brand {
        display: block;
        a {
          color: inherit;
          display: block;
        }
      }
    }
  }
  .bottom_app {
    padding-top: 0.32rem;
    .tel {
      text-align: left;
      font-size: 0.64rem;
      color: #fff;
      margin-bottom: 0.1rem;
    }
    .time {
      text-align: left;
      font-size: 0.22rem;
      color: #aaa;
    }
    .email {
      margin: 0.24rem auto;
      font-size: 0.28rem;
      color: #aaa;
      line-height: 0.56rem;
      text-align: left;
    }
  }
}
</style>
